<template>
  <Modal
    class="em-fn-modal"
    :width="width"
    :btns="[]"
    :closable="false"
    :maskClosable="false"
    :wrapClassName="wrapClassName"
    v-model:visible="visible"
  >
    <div class="status-modal-content">
      <LoadingOutlined v-if="mode === 'loading'" class="status-modal-loading-icon" />
      <Progress
        v-if="mode === 'progress' && total"
        :percent="basePercent"
        :format="formatProgress"
        class="status-modal-progress"
      />
      <div class="status-modal-text">{{ text }}</div>
    </div>
    <template #footer></template>
  </Modal>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Modal } from '@elecmap/elecmap-ui'
import { LoadingOutlined } from '@ant-design/icons-vue'
import { Progress } from 'ant-design-vue'

const visible = defineModel<boolean>('visible', { default: false })

const props = withDefaults(
  defineProps<{
    text?: string
    width?: string | number
    wrapClassName?: string
    mode?: 'text' | 'loading' | 'progress'
    current?: number
    total?: number
  }>(),
  {
    text: '',
    width: '390px',
    mode: 'text',
    current: 0,
    total: 0,
  },
)

const basePercent = computed(() => {
  if (props.mode !== 'progress' || !props.total) return 0
  const percent = (100 * props.current) / props.total
  return Math.min(100, Math.max(0, percent))
})

function formatProgress() {
  return `${props.current} / ${props.total}`
}

</script>

<style lang="less">
.status-modal-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: rgb(156 163 175);
}

.status-modal-loading-icon {
  margin-bottom: 16px;
  font-size: 36px;
}

.status-modal-progress {
  width: 100%;
}

.status-modal-text {
  text-align: center;
}

.status-modal-progress.ant-progress-line {
  white-space: nowrap;

  .ant-progress-outer {
    width: 99%;
  }

  .ant-progress-bg {
    transition: none !important;
  }

  .ant-progress-text {
    width: auto;
    color: rgb(156 163 175);
    font-size: 12px;
  }
}
</style>
